<template>
  <!-- ERP往来单位客户联系人选择--2026新版功能，单选 -->
  <div class="customer-select">
    <div class="name el-select__prefix" @click="toShowDialog">
      <slot name="prefix"></slot>
    </div>
    <div class="value" @click="toShowDialog">
      <div class="customer-name" v-if="!!customerName">{{customerName}}</div>
      <div class="placeholder" v-else>{{placeholder}}</div>
    </div>
    <el-dialog v-model="showDialog" title="选择客户" dialog-width="3" :close-on-click-modal="false" append-to-body>
      <dialog-table>
        <separate-page :show-shadow="false" :show-border="true">
          <template #category>
            <tree-dictionary :query-function="queryErpCategoryTree" v-model:dictionary-list="customerCategoryTree" @clickCategory="clickCategory" :disabled="true" code-name="typeId" label-name="fullName"/>
          </template>
          <template #default>
            <list-page :show-shadow="false" :show-border="false">
              <search-condition :show-shadow="false">
                <template #default>
                  <el-input v-model="dialogSearchInfo.searchKey" placeholder="请输入客户名称/手机号" @keydown.enter="resetSearchDialog">
                    <template #prefix>名称/手机</template>
                  </el-input>
                </template>
                <template #option>
                  <page-button type="read" el-type="primary" @click="resetSearchDialog">查询</page-button>
                </template>
              </search-condition>
              <table-list>
                <yq-table :data="dialogList" border>
                  <yq-table-column  label="客户名称" prop="fullName" min-width="180rem"/>
                  <yq-table-column label="客户编码" prop="userCode"/>
                  <yq-table-column label="联系人" prop="customerName"/>
                  <yq-table-column label="联系方式" prop="customerPhone"/>
                  <yq-table-column label="操作" align="center" width="60rem" fixed="right">
                    <template v-slot="{row}">
                      <table-button @click="selectCustomer(row)">选择</table-button>
                    </template>
                  </yq-table-column>
                </yq-table>
              </table-list>
              <form-page :show-shadow="false" v-model:page-number="dialogSearchInfo.pageNumber" v-model:page-size="dialogSearchInfo.pageSize" :total-count="dialogSearchInfo.totalCount" @onLoad="dialogQueryList"/>
            </list-page>
          </template>
        </separate-page>
      </dialog-table>
    </el-dialog>
  </div>
</template>

<script>


import {watch} from "vue";
import commonApi from "@/api/commonApi";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import SeparatePage from "@/components/h5/layout/SeparatorPage.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableList from "@/components/h5/layout/ListTable.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import Administrative from "@/components/h5/data/Administrative.vue";
export default {
  name: "",
  props: {
    modelValue: {
      type: [String],
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择客户"
    }
  },
  components: {
    Administrative,
    TreeDictionary, FormItems, FormItem,
    TableButton, DialogTable, PageButton, TableList, FormPage, SeparatePage, YqTableColumn, ListPage, SearchCondition
  },
  data() {
    return {
      customerName: "",
      value: "",
      showDialog: false,
      dialogSearchInfo: {},
      dialogList: [],
      customerCategoryTree: [],
      queryErpCategoryTree: null,
    };
  },
  created() {
    this.init();
    this.queryErpCategoryTree = commonApi.queryBtypeCategory;
    watch(() => this.modelValue, () => this.init());
  },
  methods: {
    init() {
      if (this.value !== this.modelValue) {
        // 获取客户名称
        if (this.modelValue) {
          commonApi.findBtypeInfo(this.modelValue).then(res => {
            this.customerName = res.fullName;
          })
        } else {
          this.customerName = "";
        }
      }
      this.value = this.modelValue;
    },
    toShowDialog() {
      this.showDialog = true;
      if (!this.dialogList.length) {
        this.resetSearchDialog();
      }
    },
    clickCategory(data) {
      debugger
      this.dialogSearchInfo.parentId = data.typeId;
      this.resetSearchDialog();
    },
    resetSearchDialog() {
      this.dialogSearchInfo.pageNumber = 1;
      this.dialogQueryList();
    },
    dialogQueryList() {
      commonApi.queryBtypeExternalByPage(this.dialogSearchInfo).then(res => {
        this.dialogList = res.records;
        this.dialogSearchInfo.totalCount = res.totalCount;
      })
    },
    // 选中某个客户
    selectCustomer(data) {
      this.value = data.typeId;
      this.customerName = data.fullName;
      this.$emit("update:modelValue", this.value);
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-select{
  display: inline-flex !important;
  border: none !important;
  align-items: center;
  padding: 0 10px;
  min-width: 240px;
  box-sizing: border-box;
  border-radius: var(--el-border-radius-base);
  box-shadow: 0 0 0 0.02667rem var(--el-border-color) inset;
  line-height: 30px;
  .name{
    font-size: 14px;
    color: var(--yq-font-color-base);
    &:not(:empty):after  {
      content: ":";
      margin-right: 8px;
    }
  }
  .value{
    flex: 1;
    color: #333;
    font-size: var(--yq-font-size-base);
    .placeholder{
      color: #999;
    }
  }
}
</style>